export enum Permission {
  DENIED = 'denied',
  GRANTED = 'granted',
  DEFAULT = 'default'
}
